<template>
	<div class="body">
		<div style="text-align:center;">
			<h1>缺陷报表</h1>
		</div>
		<div class="view">
			<el-collapse v-model="activeNames" @change="handleChange">
				<el-collapse-item title="产品检测信息" name="1">
					<CheckInfo :id="defect_statis_id" :batchInfo="batchInfo" />
				</el-collapse-item>
				<el-collapse-item title="缺陷分布统计图" name="2">
					<DefectDistribution :id="defect_statis_id" ref="defectDist" />
				</el-collapse-item>
				<el-collapse-item title="产品图像" name="3">
					<ProductImage :id="defect_statis_id" />
				</el-collapse-item>
				<el-collapse-item title="缺陷样本" name="4">
					<DefectSample :id="defect_statis_id" />
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
	import CheckInfo from './CheckInfo'
	import DefectDistribution from './DefectDistribution'
	import ProductImage from './ProductImage'
	import DefectSample from './DefectSample'
	import { defectStatisRequest } from '@/network/requests/defectStatis'

	export default {
		components: {
			CheckInfo,
			DefectDistribution,
			ProductImage,
			DefectSample,
		},
		data() {
			return {
				activeNames: ['1'],
				defect_statis_id: this.$route.query.defect_statis_id,
				batchInfo: {},
			}
		},
		methods: {
			handleChange(val) {
				if (!val) return

				var last = val[val.length - 1]
				if (last == '2') {
					this.$refs['defectDist'].resize()
				}
				console.log(val)
			},
		},
		async created() {
			//获取批次信息。
			var defectStatisInfo = (await defectStatisRequest.getDocumentById(this.defect_statis_id)).data
			this.batchInfo = defectStatisInfo

			console.log('批次信息', defectStatisInfo)
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background:#eee;overflow: scroll;')
		},
		destroyed() {
			document.querySelector('body').removeAttribute('style')
		},
	}
</script>

<style lang="less" scoped>
	body {
		overflow: auto;
	}
	.body {
		width: 1024px;
		margin: 0 auto;
	}

	.view {
		background-color: #fff;
		padding: 50px;
		border-radius: 10px;
		border: 1px #eee solid;
		margin-bottom: 50px;
		/deep/ label.el-form-item__label {
			width: 90px;
			color: #99a9bf;
		}

		/deep/.el-form-item {
			margin-bottom: 0;
		}
	}
</style>
